import {mapGetters} from 'vuex'

export const reservationsMixin = {
    computed: {
        ...mapGetters([
            'getSelectedProductCommissions',
            'account',
            'getAudienceTypeList'
        ]),
        paxTotal: function() {
            let n = 0;

            if (this.reservation.event !== undefined && this.reservation.event.products !== undefined && this.reservation.event.products) {
                this.reservation.event.product.prices.forEach(price => {
                    n += price.quantity;
                });
            }

            return n;
        },
        extrasQuantityTotal: function() {
            let n = 0;

            this.reservation.event.product.extras.forEach(extra => {
                n += extra.quantity;
            });

            return n;
        },
        extrasPriceTotal: function() {
            let n = 0;

            this.reservation.event.product.extras.forEach(extra => {
                if (!extra.priceIncluded) {
                    let quantity = extra.item.quantity;
                    let value = extra.item.priceTotal;

                    // If taxes aren't included in the final price we have to add them
                    // to calculate the final value

                    if (!extra.item.priceIncludeTaxes && extra.item.vatType != 0) {
                        value = extra.item.priceTotal + (extra.item.priceTotal * extra.item.vatType * 0.01)
                    }

                    n += quantity * value;
                }
            });

            return n;
        },
        extrasTaxPriceTotal: function() {
            let n = 0;

            this.reservation.event.product.extras.forEach(extra => {
                if (!extra.priceIncluded) {
                    let quantity = extra.item.quantity;
                    let value = extra.item.priceTotal * extra.item.vatType * 0.01;

                    n += quantity * value;
                }
            });

            return n;
        },
        taxesPriceTotal: function() {
            // The taxes are set in each product and are then calculated from each of
            // the customers' fees

            const product = this.reservation.event.product;
            const tax = product.tax / 100;
            let n = 0;

            if (product.prices.length === 1 && product.prices[0].type === 1 && product.prices[0].audienceType === null) {
                n = product.prices[0].value;
            }
            else {
                product.prices.forEach(price => {
                    n += price.quantity * price.value;
                });
            }

            return n * tax;
        },
        priceTotal: function() {
            // The base price is calculated by counting each of the customers' fees

            let n = 0;
            const product = this.reservation.event.product;

            if (product.prices.length === 1 && product.prices[0].type === 1 && product.prices[0].audienceType === null) {
                n = product.prices[0].value;

                if (product.includeTaxes) {
                    n = product.prices[0].value - (product.prices[0].value * product.tax * 0.01);
                }
            }
            else {
                product.prices.forEach(price => {
                    if (product.includeTaxes) {
                        n += (price.value - (price.value * product.tax * 0.01)) * price.quantity;
                    }
                    else {
                        n += price.quantity * price.value;
                    }
                });
            }

            return n;
        },
        promoTotal: function() {
            return 0;

            // Evaluates if we have set a promo code (validation is done elsewhere)
            // and returns the currency value of that discount. This value is calculated
            // by subtracting the percentage/amount set in the promo to finalPriceWithoutTaxes

            let promoValue = 0;

            if (this.reservation.promo_id === undefined || !this.reservation.promo_id) {
                return 0;
            }

            let total = this.priceTotal;
            let promo = this.reservation.event.product.promos.find(a => a.id === this.reservation.promo_id);

            if (promo) {
                // Calculate the discount. Promos are allowed to work in two ways:
                // * Percentage-based: when its type is 'percentage' the value must be between 1 and 100
                // * Currency based: when the type is 'currency' the value must not exceed the total price

                if (promo.type === 'percentage' && promo.value > 0 && promo.value <= 100) {
                    promoValue = total * (promo.value/100);
                }
                else if (promo.type === 'currency' && promo.value <= total) {
                    promoValue = promo.value;
                }
            }

            return promoValue;
        },
        discountTotal: function() {
            return 0;

            // Returns the currency value of the discount. Already takes into
            // account the fact of having/not having extras included

            if (this.reservation.billing === undefined || this.reservation.billing.discount === undefined || this.reservation.billing.discount.value === undefined) {
                return 0;
            }

            let discountValue = 0;

            // The discount can either be calculated WITH the extras or not
            // Also, it can be a value of type 'percentage' or '€'

            if (this.reservation.billing.discount.value > 0) {
                let discount = this.reservation.billing.discount;
                let sum = this.priceTotal;

                // Add extras if set as true

                if (discount.includeExtras) {
                    sum += this.extrasPriceTotal;
                }

                // Calculate the discount

                if (discount.type === 'percentage' && discount.value > 0 && discount.value <= 100) {
                    discountValue = sum * (discount.value/100);
                }
                else if (discount.type === 'currency' && discount.value <= sum) {
                    discountValue = discount.value;
                }
            }

            return discountValue;
        },
        finalPriceWithoutTaxes: function() {
            // The 'raw' final price (without taxes)

            let value = this.priceTotal + this.extrasPriceTotal - this.discountTotal - this.promoTotal;

            return !isNaN(value) ? value : 0;
        },
        finalPrice: function() {
            // The total amount to pay is the sum of each of the customers' fees
            // plus each of those taxes plus extras plus commission. It's the "actual" total
            let value = this.finalPriceWithoutTaxes + this.taxesPriceTotal;

            return !isNaN(value) ? value : 0;
        },
        outstanding: function() {
            // The outstanding amount is calculated by subtracting the product's deposit %
            // to the total earnings (plus taxes, minus discount)

            return this.finalPrice - this.deposit;
        },
        deposit: function() {
            // The deposit is set in the product and is always a
            // percentage of the total earnings (without taxes)

            let value = this.reservation.event.product.paymentValue * (this.priceTotal + this.extrasPriceTotal) / 100;

            return !isNaN(value) ? value : 0;
        },
        commissionPercentage: function() {
            return this.reservation.event.product.commission * 100;
        },
        commission: function() {
            // The commission is set in the product and is always a
            // percentage of the total earnings (without taxes)

            let value = this.reservation.event.product.commission * (this.priceTotal + this.extrasPriceTotal);

            return !isNaN(value) ? value : 0;
        },
        // New reservation (2017-12-07)
        reservationTotalCost: function(){
            if(!this.reservation){
                return false;
            }

            let totals = {
                withoutDiscount :{
                    noVat: 0,
                    withVat: 0
                },
                withDiscount :{
                    noVat: 0,
                    withVat: 0
                },
                totalTicket: 0,
                totalExtras: 0,
                totalToAgent: 0,
                totalDiscount: 0,
                agentCommission: 0,
                agentDeposit: null,
            }


            // ------------------------------ set arrays --------------------------------------
            // personType
            let personTypeArr = [];
            if(this.reservation.event.eventGenderPrices.length > 0){
                personTypeArr = this.reservation.event.eventGenderPrices;
            } else if (this.reservation.bookingGenderPrices.length > 0) {
                personTypeArr = this.reservation.bookingGenderPrices;

            }

            let reservationAgent = [];
            if(this.reservation.agent &&  this.reservation.agent > 0){
                reservationAgent = this.reservation.agent;
            } else if (this.reservation.creatorAgent && this.reservation.creatorAgent.commission && this.reservation.creatorAgent.commission.defaultCommission) {
                reservationAgent = this.reservation.creatorAgent;

            }


            //ticket cost
            for(let personType of personTypeArr){
                totals.withoutDiscount.noVat += personType.netprice * personType.quantityToBook;
                totals.withoutDiscount.withVat += personType.grossprice * personType.quantityToBook;

                totals.totalTicket += personType.grossprice * personType.quantityToBook;
            }


            //extras
            if(this.reservation.event.eventComponents.length > 0){
                for(let extra of this.reservation.event.eventComponents){
                    //both now have taxes, without taxes needs to be worked on
                    totals.withoutDiscount.noVat += extra.component.netprice * extra.quantityBooked;
                    totals.withoutDiscount.withVat += extra.component.grossprice * extra.quantityBooked;

                    totals.totalExtras += extra.component.grossprice * extra.quantityBooked;
                }
            } else {
                for(let extra of this.reservation.event.product.extras){
                    //both now have taxes, without taxes needs to be worked on
                    if(extra.quantityBooked){
                        totals.withoutDiscount.noVat += extra.item.netprice * extra.quantityBooked;
                        totals.withoutDiscount.withVat += extra.item.grossprice * extra.quantityBooked;

                        totals.totalExtras += extra.item.grossprice * extra.quantityBooked;
                    }
                }
            }

            // aply discount
            let discountValue = this.reservation.billing.discountValue;
            if(this.reservation.billing.discountType == 0){
                //discount is eur
                totals.withDiscount.noVat = totals.withoutDiscount.noVat - discountValue
                totals.withDiscount.withVat = totals.withoutDiscount.withVat - discountValue
            } else {
                // discount is percent
                totals.withDiscount.noVat = totals.withoutDiscount.noVat *  (1 - (discountValue / 100))
                totals.withDiscount.withVat = totals.withoutDiscount.withVat *  (1 - (discountValue / 100))
            }

            //total discount
            totals.totalDiscount = totals.withoutDiscount.withVat - totals.withDiscount.withVat

            // agent commission
            if(this.reservation.billing.agentCommision){
                let defaultCommission = this.reservation.billing.agentCommision
                totals.totalToAgent = totals.withDiscount.withVat *  (defaultCommission / 100)
                totals.agentCommission = defaultCommission;
            }

            // depoist
            if(this.reservation.agent){

                    if(this.reservation.agent.depositValue > 0){
                        //deposit
                        // depositType = 0 -> fixed amount €
                        if(this.reservation.agent.depositType == 1){
                            // %
                            totals.agentDeposit = (this.reservation.agent.depositValue  / 100) * totals.withDiscount.withVat
                        } else {
                            // €
                            if(this.reservation.agent.depositValue > totals.withDiscount.withVat){
                                totals.agentDeposit = totals.withDiscount.withVat
                            } else {
                                totals.agentDeposit = this.reservation.agent.depositValue
                            }
                        }
                    } else {
                        // full amount
                        totals.agentDeposit = totals.withDiscount.withVat

                    }
            }

            return totals
        },
        paid: function() {
            // What the customer has paid so far. Sums every entry in the
            // reservation's payments array
            if (this.reservation.billing.payments === undefined || this.reservation.billing.payments === null) {
                return 0;
            }

            let paid = 0;

            // this.reservation.billing.payments.forEach(p => {
            //     if(p.paymentDirection == 0 ){
            //         paid += parseFloat(p.value);
            //     } else {
            //         paid -= parseFloat(p.value);
            //     }
            // });

            this.reservation.billing.payments.forEach(paymentRow => {
                if(paymentRow.paymentDirection == 0 ){
                    paid += parseFloat(paymentRow.value);
                } else {
                    paid -= parseFloat(paymentRow.value);
                }
            })

            return Math.round(paid * 100) / 100;
        },
        due: function() {
            return this.reservationTotalCost.withDiscount.withVat - this.paid;
        },
        isReservationReadOnly: function() {
            //reservation is read online if it is
            //canceled(-5)
            //rebooked parent (20)
            //pending (5)
            if(!this.reservation){
                return true
            }

            if(this.reservation.status == -5 || this.reservation.status == 20 || this.reservation.status == 5){
                return true
            } else {
                return false
            }
        },
        resourcesWithAvailability: function () {
            let treatedArray = JSON.parse(JSON.stringify(this.reservation.event.eventResources))

            if(this.reservation.event.availabilityType == "2"){
                treatedArray.map(resource => {
                    resource.name = resource.name + ' ('+resource.capacityAvailable+')'
                })
            }

            return treatedArray
        },
        totalSelectedTickets: function() {
            let total = 0;

            //this makes this method work on create and edit reservation
            let eventGenderPricesHolder = this.reservation.bookingGenderPrices? this.reservation.bookingGenderPrices : this.reservation.event.eventGenderPrices

            // is per person
            if(eventGenderPricesHolder[0].genderPriceType == 2 ){
                for(let personType of eventGenderPricesHolder){
                    total += personType.quantityToBook
                }

                return total
            } else if(eventGenderPricesHolder[0].genderPriceType == 1) {
                //has particpants (like "Adult", "Children")
                if(eventGenderPricesHolder.filter(genderPrice => genderPrice.isExcludedFromBilling).length > 0){
                    for(let personType of eventGenderPricesHolder){
                        total += personType.isExcludedFromBilling? personType.quantityToBook : 0
                    }

                    return total
                } else {
                    // has no participants, so we count as 1 person
                    return 1
                }
            }
        },
        loggedUserAccessList: function() {
            if(!this.getSelectedProductCommissions){
                return false
            }
            let thisSellerPermissions = null
            thisSellerPermissions = this.getSelectedProductCommissions.filter(row => {
                if(row.userAccount){
                    return row.userAccount.id == this.account.id
                }
            })[0]

            return thisSellerPermissions
        },
        selectedSellerAccessList: function() {
            if(!this.getSelectedProductCommissions){
                return false
            }
            let thisSellerPermissions = null
            if(this.reservation.creatorAgent){
                thisSellerPermissions = this.getSelectedProductCommissions.filter(row => {
                    if(row.agent){
                        return row.agent.id == this.reservation.creatorAgent.id
                    }
                })[0]
            } else if(this.reservation.creatorSupplier){
                thisSellerPermissions = this.getSelectedProductCommissions.filter(row => {
                    if(row.userAccount){
                        return row.userAccount.id == this.reservation.creatorUserAccount.id
                    }
                })[0]
            }

            return thisSellerPermissions
        },
        reservationHasUnsavedChanges: function () {
            let output = false
            for (var key in this.reservation.updateFlags) {
               if (this.reservation.updateFlags.hasOwnProperty(key)) {
                  if (this.reservation.updateFlags[key] == true){
                      output = true
                  }
               }
            }
            return output
        },
    },
    methods: {
        setReservationToCancel: function(showRefundPopup) {

            // Cancel to status:
            // if the reservation is made by GetYourGuide or Pluralo Locals, wen canceled it should change to -6 (pending cancelation)
            // else we use -5 (canceled)
            let changeStatusToVal
            if(this.reservation.channelType == 202 || this.reservation.channelType == 201){
                changeStatusToVal = "-6"
            } else {
                changeStatusToVal = "-5"
            }


            if(showRefundPopup == false){
                this.$set(this.reservation, 'changeStatusTo', changeStatusToVal)
                // this.toggleAddPayment()
                return true

            } else {

                let vm = this
                return this.$dialog.confirm('\
                <div class="fs-larg font-weight-600 mb-4">Are you sure you want to cancel this booking?</div>\
                <p>By cancelling this reservation you must refund your customer.<br>This can not be undone.</p>')
                .then(function () {
                    vm.$set(vm.reservation, 'changeStatusTo', changeStatusToVal)
                    vm.toggleAddPayment()
                    return true

                })
                .catch(function () {
                    return false
                });
            }


        },
        readOnlyShowMessage: function () {
            this.$toasted.info('This reservation is read only')
        },
        firstResourceWithAvailability: function() {
            let arrayToSearch = this.resourcesWithAvailability

            for (let resource of arrayToSearch) {
                if(resource.availability > 0){
                    return resource
                }
            }

            //if nothing found return the first resource
            return arrayToSearch[0]
        },
        paxManuallyChanged: function (personPrice) {
            if(this.reservation.event.availabilityType != 1 && this.totalSelectedTickets > this.reservation.event.quantityAvailable){
                personPrice.quantityToBook = 0
                personPrice.quantityToBook = this.reservation.event.quantityAvailable - this.totalSelectedTickets
                this.$toasted.info('The value entered is over the available tickets, applied maximum available');
                console.log('OVER OVER OVER!! Max: '+ this.reservation.event.quantityAvailable + ' ' + this.totalSelectedTickets, personPrice);
            }
            if(personPrice.quantityToBook < 0){
                personPrice.quantityToBook = 0
            }
            this.updateCalculations();
        },
        audienceTypeIdToObj: function (audienceTypeId) {
            if(audienceTypeId) {
                return this.getAudienceTypeList.filter((audienceType) => {
                    return audienceType.id == audienceTypeId;
                })[0]
            } else {
                return null;
            }
        },
        genderPriceObj: function (personPrice) {
            if(!personPrice.audienceType){
                return null
            }

            return {
                name: personPrice.audienceTypeDescription? personPrice.audienceTypeDescription : this.audienceTypeIdToObj(personPrice.audienceType).description,
                description: personPrice.audienceTypeLabel? personPrice.audienceTypeLabel : null,
            }
        }
    },
    watch: {
        'reservation.customer': {
            deep: true,
            handler: function (newVal, oldVal) {
                if(this.reservation && this.reservation.updateFlags && oldVal){
                    this.$set(this.reservation.updateFlags, 'customer', true)
                }
            }
        },
        'reservation.note': {
            deep: true,
            handler: function (newVal, oldVal) {
                if(oldVal){
                    this.$set(this.reservation.updateFlags, 'customer', true)
                }
            }
        },
        'reservation.bookingOperatorCode': function (newVal, oldVal) {
            if(this.reservation && this.reservation.updateFlags && newVal && typeof oldVal != 'undefined'){
                this.$set(this.reservation.updateFlags, 'voucher', true)
            }
        },
        'reservation.selectedResource': function (newVal, oldVal) {
            if(this.reservation && this.reservation.updateFlags && oldVal && newVal.id != oldVal.id){
                this.$set(this.reservation.updateFlags, 'reservation', true)
            }
        },
        'reservation.creatorUserAccount': function (newVal, oldVal) {
            if(this.reservation && this.reservation.updateFlags && oldVal && newVal.id != oldVal.id){
                console.log('reservation.creatorUserAccount', newVal, oldVal);
                this.$set(this.reservation.updateFlags, 'reservation', true)
            }
        },
        'reservation.changeStatusTo': function (newVal, oldVal) {
            // is changing flag "customer"?
            if(this.reservation && this.reservation.updateFlags && newVal !== null){
                this.$set(this.reservation.updateFlags, 'reservation', true)
            }
        },
        // 'reservation.bookingComponents': function (newVal, oldVal) {
        //     if(this.reservation && this.reservation.updateFlags && oldVal !== undefined){
        //         this.$set(this.reservation.updateFlags, 'extras', true)
        //     }
        // },
        'reservation.paxCheckedIn': function (newVal, oldVal) {
            if(this.reservation && this.reservation.updateFlags && oldVal !== undefined){
                this.$set(this.reservation.updateFlags, 'checkins', true)
            }
        },
        'reservation.paxNoShow': function (newVal, oldVal) {
            if(this.reservation && this.reservation.updateFlags && oldVal !== undefined){
                this.$set(this.reservation.updateFlags, 'checkins', true)
            }
        },
        'reservation.bookingGenderPrices':{
            deep: true,
            handler: function (newVal, oldVal) {
                if(this.reservation && this.reservation.updateFlags && oldVal !== undefined){
                    this.$set(this.reservation.updateFlags, 'pax', true)
                }
            }
        },
        'reservation.transport':{
            deep: true,
            handler: function (newVal, oldVal) {
                if(this.reservation && this.reservation.updateFlags && oldVal !== undefined){
                    this.$set(this.reservation.updateFlags, 'transport', true)
                }
            }
        },
        'reservation.attachCommission':{
            deep: true,
            handler: function (newVal, oldVal) {
                if(this.reservation && this.reservation.updateFlags && oldVal !== undefined){
                    this.$set(this.reservation.updateFlags, 'commissions', true)
                }
            }
        },
        'reservation.attachDiscount':{
            deep: true,
            handler: function (newVal, oldVal) {
                // if(this.reservation && this.reservation.updateFlags && oldVal !== undefined && oldVal !== null){
                //     this.$set(this.reservation.updateFlags, 'discount', true)
                // }
            }
        },
        'reservation.billing':{
            deep: true,
            handler: function (newVal, oldVal) {
                if(this.reservation && this.reservation.updateFlags && oldVal !== undefined){
                    this.$set(this.reservation.updateFlags, 'billing', true)
                }
            }
        },
    },
}



// WEBPACK FOOTER //
// ./src/mixins/reservations.js